export default "__VITE_ASSET__63094f9c__"